module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iterations-calendar",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "iterations-calendar-title"
  }, [(!_vm.selectedIteration) ? [_c('span', {
    staticClass: "iterations-calendar-show-link",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.select-different-flight-month')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShown),
      expression: "isShown"
    }],
    staticClass: "iterations-calendar-years"
  }, _vm._l((_vm.years), function(year) {
    return _c('span', {
      staticClass: "iterations-calendar-year",
      class: {
        'iterations-calendar-year-active': year == _vm.activeYear
      },
      on: {
        "click": function($event) {
          _vm.onYearClicked(year)
        }
      }
    }, [_vm._v(_vm._s(year))])
  }))] : [_c('span', {
    staticClass: "iterations-calendar-flight-started"
  }, [_vm._v(_vm._s(_vm.selectedIteration.fullMonthName) + " " + _vm._s(_vm.$t('pos.campaign.flight')) + "\n (" + _vm._s(_vm.$t('pos.campaign.started')) + " " + _vm._s(_vm.$t('fn.date', {
    timestamp: _vm.selectedIteration.start_date
  })) + ")")]), _c('span', {
    staticClass: "change-flight-month",
    on: {
      "click": _vm.onChangeFlightMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.change-flight-month')))]), _c('div', {
    staticClass: "row mt-3",
    attrs: {
      "data-campaign-stats-iteration": ((_vm.selectedIterationData.month) + "-" + (_vm.selectedIterationData.year))
    }
  }, _vm._l((_vm.stats), function(data, key) {
    return _c('div', {
      key: key,
      class: data.details ? 'col-md-12' : _vm.colWidth
    }, [_c('stats-info', {
      staticClass: "stats-info",
      attrs: {
        "icon": data.icon,
        "title": _vm.$t("fn.complex.stats", {
          name: data.slug
        }),
        "value": _vm.statValue(data.slug, data.value),
        "details": data.details,
        "size": "md"
      }
    })], 1)
  }))]], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShown),
      expression: "isShown"
    }],
    staticClass: "iterations-calendar-box"
  }, _vm._l((_vm.years), function(year) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeYear == year),
        expression: "activeYear == year"
      }],
      staticClass: "row"
    }, _vm._l((_vm.calendarMonths), function(month, key) {
      return _c('div', {
        staticClass: "col-3"
      }, [_c('div', {
        staticClass: "iterations-calendar-month",
        class: {
          'iterations-calendar-month-enabled': _vm.hasIteration(year, key), future: _vm.hasFutureIterations(year, key)
        },
        attrs: {
          "data-flight-box": ("box-" + key)
        },
        on: {
          "click": function($event) {
            _vm.onMonthClicked(year, key)
          }
        }
      }, [_vm._v(_vm._s(month.name) + " '" + _vm._s(month.year))])])
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb8463d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/iterations-calendar/IterationsCalendar.vue
// module id = 2040
// module chunks = 1